var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZimbabweLotto6From45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 75.891,
    cy: 10.193,
    r: 8.647,
    gradientTransform: "matrix(.7374 -.6754 .5865 .6404 13.948 54.924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fffbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#fbe9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#f3c4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#f0b6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#efafc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ec9bbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#ea8db3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#e97ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#e86c9e"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 60.519,
    cy: 13.494,
    r: 8.647,
    gradientTransform: "matrix(.7374 -.6754 .5865 .6404 7.976 45.729)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fffbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#fbe9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#f3c4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#f0b6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#efafc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ec9bbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#ea8db3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#e97ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#e86c9e"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 45.489,
    cy: 10.183,
    r: 8.647,
    gradientTransform: "matrix(.7374 -.6754 .5865 .6404 5.971 34.386)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fffbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#fbe9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#f3c4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#f0b6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#efafc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ec9bbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#ea8db3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#e97ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#e86c9e"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 30.333,
    cy: 7.1,
    r: 8.647,
    gradientTransform: "matrix(.7374 -.6754 .5865 .6404 3.8 23.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fffbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#fbe9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#f3c4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#f0b6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#efafc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ec9bbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#ea8db3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#e97ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#e86c9e"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 15.177,
    cy: 11.712,
    r: 8.647,
    gradientTransform: "matrix(.7374 -.6754 .5865 .6404 -2.884 14.463)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fffbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#fbe9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#f3c4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#f0b6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#efafc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ec9bbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#ea8db3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#e97ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#e86c9e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.975 58.698h88.627l4.266-15.538H8.241z",
    fill: "#858384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.131 57.731h88.627l4.266-15.528H7.397z",
    fill: "#f09abe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.172 43.72c2.56 0 4.835 1.185 6.342 3.034.427-4.143 3.906-7.375 8.124-7.375 3.745 0 6.901 2.541 7.868 6.001a8.14 8.14 0 0 1 6.399-3.109c3.801 0 7.006 2.616 7.916 6.171a8.14 8.14 0 0 1 6.333-3.034 8.14 8.14 0 0 1 6.579 3.346c.796-3.707 4.067-6.484 7.992-6.484 4.512 0 8.172 3.678 8.172 8.219s-3.659 8.219-8.172 8.219c-2.702 0-5.091-1.318-6.589-3.346-.787 3.707-4.067 6.484-7.982 6.484-3.811 0-7.006-2.616-7.916-6.171a8.14 8.14 0 0 1-6.333 3.034c-3.754 0-6.911-2.541-7.868-6.001a8.125 8.125 0 0 1-6.399 3.109c-2.56 0-4.835-1.185-6.342-3.034-.427 4.143-3.906 7.375-8.124 7.375-4.512 0-8.172-3.678-8.172-8.219 0-4.531 3.659-8.219 8.172-8.219z",
    fill: "#c80061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.004 41.084c4.512 0 8.172 3.678 8.172 8.229 0 4.541-3.659 8.219-8.172 8.219s-8.172-3.678-8.172-8.219 3.659-8.229 8.172-8.229z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.433 44.213c4.512 0 8.172 3.678 8.172 8.229 0 4.541-3.659 8.219-8.172 8.219s-8.172-3.678-8.172-8.219 3.659-8.229 8.172-8.229z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.185 41.075c4.512 0 8.172 3.678 8.172 8.229 0 4.541-3.659 8.219-8.172 8.219s-8.172-3.678-8.172-8.219 3.659-8.229 8.172-8.229z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.823 38.155c4.512 0 8.172 3.678 8.172 8.229 0 4.541-3.659 8.219-8.172 8.219s-8.172-3.678-8.172-8.219c0-4.55 3.65-8.229 8.172-8.229z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.451 42.525c4.512 0 8.172 3.678 8.172 8.229 0 4.541-3.659 8.219-8.172 8.219s-8.172-3.678-8.172-8.219 3.659-8.229 8.172-8.229z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.01 55.968h7.593l.654-2.37h-4.19l1.962-7.119h-3.394l-2.626 9.489zm28.297-8.513h2.541l-1.905 6.949h3.29l1.905-6.949h2.749l.711-2.541h-8.579l-.711 2.541zm14.144 3.318h2.379l-1.915 6.958h3.394l1.915-6.958h2.797l.72-2.55h-8.579zm-22.496-9.186c2.759 0 4.361 2.294 3.583 5.129s-3.64 5.129-6.399 5.129c-2.749 0-4.361-2.294-3.574-5.129.768-2.834 3.631-5.129 6.389-5.129zm-.588 2.417c.976.076 1.365 1.346.872 2.834s-1.678 2.635-2.654 2.55c-.976-.076-1.365-1.337-.872-2.825s1.678-2.635 2.654-2.56zm43.74.502c2.787 0 4.37 2.285 3.536 5.11-.834 2.816-3.773 5.11-6.56 5.11s-4.37-2.285-3.536-5.11 3.773-5.11 6.56-5.11zm-.635 2.417c.976.076 1.356 1.337.834 2.816s-1.744 2.616-2.721 2.541c-.986-.076-1.356-1.337-.834-2.816.512-1.479 1.735-2.616 2.721-2.541z",
    fill: "#c80061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.214 55.437h7.593l.654-2.37h-4.19l1.962-7.119H18.84l-2.626 9.489zm28.307-8.38h2.541l-1.905 6.949h3.29l1.905-6.949H53.1l.711-2.541h-8.579l-.711 2.541zm14.135 3.318h2.389l-1.915 6.958h3.384l1.915-6.958h2.806l.711-2.55h-8.579zm-22.249-9.309c2.787 0 4.323 2.285 3.432 5.11-.891 2.816-3.877 5.11-6.664 5.11S28.85 49 29.741 46.175s3.877-5.11 6.664-5.11zm-.692 2.417c.986.076 1.327 1.337.777 2.816s-1.792 2.616-2.778 2.541-1.327-1.337-.777-2.816c.559-1.479 1.801-2.616 2.778-2.541zm43.503.626c2.787 0 4.323 2.285 3.432 5.11s-3.877 5.11-6.664 5.11-4.323-2.285-3.422-5.11 3.868-5.11 6.655-5.11zm-.683 2.417c.976.076 1.327 1.337.777 2.816s-1.792 2.616-2.778 2.541-1.327-1.337-.777-2.816 1.792-2.616 2.778-2.541z",
    fill: "#feffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabweLotto6From45);
export default __webpack_public_path__ + "static/media/zimbabwe_lotto_6_from_45.713b6d787696cbc55efe5df41c632d73.svg";
export { ForwardRef as ReactComponent };